module.exports = __webpack_public_path__ + "static/media/clock_icon.ce38d384.svg";